<!-- <app-home-admin *ngIf="role == 'Admin'"></app-home-admin> -->
<!-- <app-home-admin *ngIf="role == 'AdnocCoordinator'"></app-home-admin> -->
<app-home-supplier-admin *ngIf="role == 'SupplierAdmin'"></app-home-supplier-admin>
<app-home-supplier *ngIf="role == 'Supplier'"></app-home-supplier>
<app-home-reviewer *ngIf="role == 'Reviewer'"></app-home-reviewer>
<app-home-buyer *ngIf="role == 'Buyer' || role == 'Admin' || role == 'AdnocCoordinator'"></app-home-buyer>